import { Pagination } from "../Pagination";
import { ListTable } from "./ListTable";
import { observer } from "mobx-react-lite";
import { ListProps } from "@/types/list";
import { ListToolbar } from "./ListToolbar";
import { cx } from "class-variance-authority";
import { Selected } from "./Selected";

const ListInner = <TData,>({
	table,
	layout,
	pagination,
	toolbar,
	tableConfig,
	tableName,
	expandedRowPanel,
}: ListProps<TData>) => {
	const tablePagination = table.getState().pagination;
	const tableMeta = table.options.meta;

	return (
		<div className={cx("w-full", layout.className)}>
			{toolbar && !toolbar.hideToolbar && (
				<ListToolbar loading={layout.loading} tableName={tableName} table={table} {...toolbar} />
			)}
			<Selected table={table} />
			{pagination && tablePagination.pageSize >= 20 && (
				<Pagination
					page={tablePagination.pageIndex}
					pageSize={tablePagination.pageSize}
					total={pagination.total}
					onPageChange={tableMeta?.setPage ? tableMeta.setPage : () => {}}
					onPerPageChange={tableMeta?.setPageSize ? tableMeta.setPageSize : () => {}}
					className="py-0"
					loading={layout.loading}
				/>
			)}
			<div className={cx("rounded-md border overflow-x-auto table-scrollbar", layout.tableWrapperClassName)}>
				<ListTable table={table} layout={layout} {...tableConfig} expandedRowPanel={expandedRowPanel} />
			</div>

			{pagination && (
				<Pagination
					page={tablePagination.pageIndex}
					pageSize={tablePagination.pageSize}
					total={pagination.total}
					onPageChange={tableMeta?.setPage ? tableMeta.setPage : () => {}}
					onPerPageChange={tableMeta?.setPageSize ? tableMeta.setPageSize : () => {}}
					loading={layout.loading}
					className={pagination.className}
				/>
			)}
		</div>
	);
};

export const List = observer(ListInner) as typeof ListInner;
